import React from 'react';
import './btn1.css'

const Btn1 = (props) => {
    return ( 
        <button className={props.btn1style}>{props.btntext}</button>
     );
}
 
export default Btn1;